<template>
  <div class="d-flex flex-column border">
    <div class="d-flex flex-column border-bottom p-2">
      <div class="d-flex align-items-center">
        <span>出貨方式</span>
        <div>
          <select class="form-control">
            <option>郵局宅配（2）</option>
            <option>超商</option>
            <option>現場</option>
          </select>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <span>搜尋條件</span>
        <div>
          <select class="form-control">
            <option>依關鍵字搜尋</option>
            <option>依出貨群組選擇</option>
            <option>依出貨日期搜尋</option>
          </select>
        </div>
      </div>
      <div class="d-flex align-items-center ml-5 pl-3">
        <div>
          <b-form-input></b-form-input>
        </div>
        <div>
          <b-form-input></b-form-input>
        </div>
        <div>
          <b-form-datepicker></b-form-datepicker>
        </div>
        <div>
          <b-form-datepicker></b-form-datepicker>
        </div>
        <div>
          <button type="button" class="btn btn-primary">搜尋</button>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column p-2 align-items-start">
      <span>總共 2 筆</span>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th></th>
            <th>核銷單號</th>
            <th>出貨日</th>
            <th>品項</th>
            <th>數量</th>
            <th>收件人</th>
            <th>地址</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="7">
              <div class="d-flex align-items-center">
                <span>郵局宅配2筆</span>
                <span class="text-warning ml-2">大宗單編號</span>
                <div>
                  <b-form-input></b-form-input>
                </div>
                <div>
                  <button type="button" class="btn btn-warning text-white">帶入</button>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <div class="d-flex flex-column">
                <div>
                  <b-form-input></b-form-input>
                </div>
                <div>
                  <button type="button" class="btn btn-primary">核銷</button>
                </div>
              </div>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {

};

</script>

<style>

</style>
